module.exports = __webpack_public_path__ + "static/media/18.47aa7e86.jpg";